import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Button } from '@/components/ui/button'
import SiteHeader from '@/components/SiteHeader'
import SiteFooter from '@/components/SiteFooter'

// 404 page (2026-08-25 design-system pass). Unknown URLs land here instead of
// silently redirecting home. Known retired marketplace paths still redirect
// home in App.js so old inbound links keep working.

export default function NotFound() {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen bg-white font-sans flex flex-col">
      <Helmet>
        <title>Page not found · BragBox</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <SiteHeader source="not_found_nav" />

      <main className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-md text-center">
          <p className="text-xs font-bold tracking-widest uppercase mb-4" style={{ color: '#C4A35A' }}>
            404
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#1F2A44', fontFamily: 'Manrope' }}>
            That page does not exist
          </h1>
          <p className="text-gray-600 mb-8">
            The link may be old, or the page has moved. Your wins are safe either way.
          </p>
          <Button
            size="lg"
            className="px-10 py-4 h-auto"
            style={{ backgroundColor: '#1F2A44', color: 'white' }}
            onClick={() => navigate('/')}
          >
            Back to the homepage
          </Button>
        </div>
      </main>

      <SiteFooter />
    </div>
  )
}
